var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.value,"width":"1000","persistent":""}},[_c('v-card',{staticClass:"modal"},[_c(_vm.componentName,{key:_vm.id,tag:"component",attrs:{"modal":true,"id":_vm.id},on:{"add":function (newId) {
          _vm.$emit('add', newId);
        },"update":function (item) {
          _vm.$emit('update', item);
        },"close":function($event){return _vm.$emit('input')}}}),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }